import { createSelector } from '@ngrx/store';
import * as Utils from '@shared/core/utils';
import { getCartSimpleItemByTempId } from '../getCartSimpleItemByTempId';

export const getCartSimpleItemDescription = (tempId: number) =>
    createSelector(getCartSimpleItemByTempId(tempId), (simpleItem) => {
        if (!simpleItem) return null;

        return Utils.Items.generateDescriptionForSimpleItem(simpleItem);
    });
